import React from "react";
import { FaRegWindowMinimize } from "react-icons/fa";

interface Props {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

const RemoveItem: React.FC<Props> = ({
  onClick,

  className,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center justify-center w-[17px] h-[17px] absolute right-0 top-[6px]  bg-[#EA4335]  rounded-full     text-[12px] ${className}`}
    >
      <FaRegWindowMinimize className="text-white flex text-[9px] w-auto h-auto mt-[-7px]" />
    </button>
  );
};

export default RemoveItem;
